/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { CAWeekDay } from 'src/app/model/control-access';
import { selectMtmaWeeklyScheduleModify } from 'src/app/store/device/device.selector';
import { CustomValidators } from 'src/app/validators/custom.validators';
import moment from 'moment';
import { MtmaTimeslice } from 'src/app/model/mtma-rules-access';

@Component({
	selector: 'app-mtma-control-access-weekly-schedule-dialog',
	templateUrl: './mtma-control-access-weekly-schedule-dialog.component.html',
})

export class MtmaControlAccessWeeklyScheduleDialogComponent implements OnInit, OnDestroy {

	weeklyScheduleModify$: Observable<boolean | undefined>;
	weeklyScheduleModifySub: Subscription | undefined;


	weeklySchedule: MtmaTimeslice;
	editMode = false;

	weeklyScheduleForm: FormGroup;

	editedSub: Subscription;
	addedSub: Subscription;
	groupModifySub: Subscription;
	daysOfWeek: CAWeekDay[] = [
		{ Value: '1', Name: 'MON', Enable: false },
		{ Value: '2', Name: 'TUE', Enable: false },
		{ Value: '3', Name: 'WED', Enable: false },
		{ Value: '4', Name: 'THU', Enable: false },
		{ Value: '5', Name: 'FRI', Enable: false },
		{ Value: '6', Name: 'SAT', Enable: false },
		{ Value: '0', Name: 'SUN', Enable: false },
	];

	// design
	screenWidth: number;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.weeklySchedule = new MtmaTimeslice();
		if (config.data !== undefined && config.data.weeklySchedule !== undefined) {
			this.weeklySchedule.Id = config.data.weeklySchedule.Id;
			this.weeklySchedule.Name = config.data.weeklySchedule.Name;
			this.weeklySchedule.Weekdays = config.data.weeklySchedule.Weekdays;
			this.weeklySchedule.DtFrom = config.data.weeklySchedule.DtFrom.split('T')[1];
			this.weeklySchedule.DtTo = config.data.weeklySchedule.DtTo.split('T')[1];
			this.editMode = true;
		} else {
			this.weeklySchedule.DtFrom = "00:00";
			this.weeklySchedule.DtTo = "23:59";
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.weeklyScheduleModify$ = this.store.select(selectMtmaWeeklyScheduleModify);
	}

	ngOnInit(): void {
		const currentWeekDays = [];
		let value = this.weeklySchedule.Weekdays;
		for (let i = 6; i > -1; i--) {
			if (value !== 0 && value / (2 ** i) >= 1) {
				currentWeekDays.unshift(i.toString());
			}
			value = value % (2 ** i);
		}
		let wDayArr;
		if (this.editMode === true) {
			wDayArr = this.daysOfWeek.map((weekday) => this.fb.control(currentWeekDays.includes(weekday.Value)));
		} else {
			wDayArr = this.daysOfWeek.map(() => this.fb.control(true));
		}
		this.weeklyScheduleForm = this.fb.group({
			'Name': new FormControl(this.weeklySchedule.Name, [Validators.required, Validators.maxLength(48)]),
			'startTime': new FormControl(this.weeklySchedule.DtFrom, Validators.required),
			'endTime': new FormControl(this.weeklySchedule.DtTo, Validators.required),
			'weekDays': this.fb.array(wDayArr, CustomValidators.multipleCheckboxRequireOne),
		});

		this.subscribeAll();

		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	subscribeAll(): void {
		this.weeklyScheduleModifySub = this.weeklyScheduleModify$
			.pipe(filter(weeklyScheduleModify => !!weeklyScheduleModify))
			.subscribe(() => {
				this.resetClose();
			});
	}

	ngOnDestroy(): void {
		this.weeklyScheduleModifySub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.resetWeeklyScheduleForm());
		this.closeDialog();
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.weeklyScheduleForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.weeklyScheduleForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	save(): void {
		const weeklySchedule = { ...this.weeklySchedule };
		weeklySchedule.Name = this.f.Name.value;

		// TIME START ELABORATION
		let startTimeStr = this.f.startTime.value.toString().toLowerCase()
		if (!/^\d$/.test(startTimeStr.charAt(0))) {
			// non è in formato numerico
			startTimeStr = startTimeStr.substring(16, 21)
			this.f.startTime.value = startTimeStr;
		}

		const datStr = moment().utc().format('yyyy-MM-DDT');
		const momTimeFrom = moment().local()
			.hours(+this.f.startTime.value.split(':')[0])
			.minutes(+this.f.startTime.value.split(':')[1]);
		weeklySchedule.DtFrom = datStr + momTimeFrom.format('HH:mm');
		// TIME START ELABORATION
		// TIME END ELABORATION
		let endTimeStr = this.f.endTime.value.toString().toLowerCase()
		if (!/^\d$/.test(endTimeStr.charAt(0))) {
			// non è in formato numerico
			endTimeStr = endTimeStr.substring(16, 21)
			this.f.endTime.value = endTimeStr;
		}
		const momTimeTo = moment().local()
			.hours(+this.f.endTime.value.split(':')[0])
			.minutes(+this.f.endTime.value.split(':')[1]);
		weeklySchedule.DtTo = datStr + momTimeTo.format('HH:mm');
		// TIME END ELABORATION
		weeklySchedule.Weekdays = this.parseDays();
		weeklySchedule.Flags = 1;
		weeklySchedule.Type = 1;

		if (this.weeklySchedule.Id) {
			this.store.dispatch(DeviceActions.editMtmaWeeklySchedule({ weeklySchedule: weeklySchedule }));
		} else {
			this.store.dispatch(DeviceActions.addMtmaWeeklySchedule({ weeklySchedule: weeklySchedule }));
		}
	}

	parseDays(): number {
		const WDControl = this.f.weekDays as FormArray;
		let value = 0;
		WDControl.controls.forEach((c, i) => {
			if (c.value) {
				value += 2 ** Number(this.daysOfWeek[i].Value);
			}
		});
		return value;
	}

	get f(): any {
		return this.weeklyScheduleForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-23rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaControlAccessWeeklyScheduleDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaControlAccessWeeklyScheduleDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	manageRespStylewithError(type: MtmaControlAccessWeeklyScheduleDialogComponent["f"], classType: string): string {
		return StandardNewValidator.manageRespStylewithError(type, classType, this.screenWidth);
	}

	showErrorRequiredCheckBox(type: MtmaControlAccessWeeklyScheduleDialogComponent["f"]): string {
		return StandardNewValidator.showErrorRequiredCheckBox(type);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicInputShortTextWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-20rem', 'w-23rem');
	}
}
